module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("Payment preferences")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('dismissable-alert', {
    attrs: {
      "title": "Your preferences have been updated. This update does not change upcoming transactions within 45 days.",
      "closeAction": _vm.hidePaymentPreferenceUpdated,
      "isShowing": _vm.paymentPreferenceWasUpdated
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "payment-preferences"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "preferences-container"
  }, [_c('div', {
    staticClass: "principal-preferences preferences"
  }, [_c('h3', {
    staticClass: "preference-type-title"
  }, [_vm._v("Principal maturity")]), _vm._v(" "), _vm._l((_vm.availablePreferences), function(preference) {
    return _c('div', {
      key: preference.id
    }, [_c('div', {
      class: {
        'radio-item': true,
        'radio-item-unselected':
        preference.name !== _vm.paymentPreference,
      },
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.6 : 1
      }),
      on: {
        "click": function($event) {
          _vm.setPrincipalPreference(preference.name)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "preference-text"
    }), _vm._v(_vm._s(preference.text) + "\n                    "), _c('label')])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "interest-preferences preferences"
  }, [_c('h3', {
    staticClass: "preference-type-title"
  }, [_vm._v("Interest payment")]), _vm._v(" "), _vm._l((_vm.availablePreferences), function(preference) {
    return _c('div', {
      key: preference.id
    }, [_c('div', {
      class: {
        'radio-item': true,
        'radio-item-unselected':
        preference.name !== _vm.interestPreference,
      },
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.6 : 1
      }),
      on: {
        "click": function($event) {
          _vm.setInterestPreference(preference.name)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "preference-text"
    }), _vm._v(_vm._s(preference.text) + "\n                    "), _c('label')])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function($event) {
        _vm.updatePaymentPreferences()
      }
    }
  }, [_vm._v("\n        Submit\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "separator mt-xl mb-lg"
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v("\n                Change your payment preferences by selecting between the\n                options we provide below.\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-811081a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorPaymentPreferences.vue
// module id = 2184
// module chunks = 1